export const GetTypeImgChange = (state = null, action) => {
    switch (action.type) {
        case 'GET_TYPE_IMG_CHANGE':
          return action.imgchange;
        default:
          return state
    }
}